import ConfigurationManager from "./configuration-manager";

export default ConfigurationManager;
